module.exports = __webpack_public_path__ + "static/img/orline2.6337467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downLoad/orline2.png
// module id = O39v
// module chunks = 1